import { parse } from "date-fns";

// Format generic data
export const formatData = (
  data,
  keyOptions,
  dataKeys,
  divisor,
  isClickable
) => {
  const isStandardArray = Array.isArray(data); // some endpoints return object arrays with time as an attribute of an element, others return an object with time as the key itself

  const formatDatum = (datum, index) => {
    let valArray = [];
    dataKeys.forEach((key) => {
      const val = keyOptions[key].secondaryDataKey
        ? datum[key][keyOptions[key].secondaryDataKey]
        : datum[key];

      valArray.push({
        [key]:
          val !== null
            ? `${keyOptions[key].negative ? "-" : ""}${(val / divisor).toFixed(
                2
              )}`
            : null,
      });
    });
    const weatherIcon = datum.weatherIcon || datum.icon;
    // shorten for day aggregates  (00:00:00 breaks formatting)
    const dateString =
      datum.time.split(" ")[1] !== "00:00:00" && datum.time.length > 10
        ? "yyyy-MM-dd HH:mm:ss"
        : "yyyy-MM-dd";

    const obj = {
      time: parse(
        datum.time.substr(0, isClickable ? 10 : 20),
        dateString,
        new Date()
      ),
      weatherIcon: weatherIcon && `${weatherIcon} (${index})`,
    };
    return Object.assign({}, obj, ...valArray);
  };

  if (isStandardArray) {
    return data.map((datum, index) => formatDatum(datum, index));
  } else {
    return Object.entries(data).map(([time, datum], index) => {
      datum.time = time;
      return formatDatum(datum, index);
    });
  }
};
export const getGraphColors = () => [
  "#6E0E0A",
  "#D74E09",
  "#F2BB05",
  "#72B01D",
  "#3F7D20",
  "#119DA4",
  "#00B4DD",
  "#124E78",
  "#454955",
  "#262528",
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/Graph/Graph.utils.js